import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { useMemo } from 'react';

import { PageLoading } from '@/ui/PageLoading';

import AdminClickupListView from './AdminClickupListView';

const GET_CLICKUP_TASKS_QUERY = gql`
  query GetClickupLiveEventTasks {
    getClickupLiveEventTasks
  }
`;

export default function AdminClickupListClient() {
  const { data, loading, error } = useQuery(GET_CLICKUP_TASKS_QUERY);

  const clickupTasksData = useMemo(() => {
    if (!data || loading) return [];
    return data.getClickupLiveEventTasks?.tasks || [];
  }, [data, loading]);

  if (loading) {
    return <PageLoading />;
  }

  if (error) {
    console.error('Error fetching ClickUp tasks:', error);
  }

  return <AdminClickupListView data={clickupTasksData} />;
}
